import styled from 'styled-components'

const DropdownItemDescription = styled.div`
  margin: 4px 0 0 0;
  font-size: 0.8125rem;
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.text.dark.tertiary};
  white-space: initial;
`

export default DropdownItemDescription
